import { IAppBarOptions } from "fwork.react.apptemplate";
import { ThemeModeToggleComponent } from "fwork-react-mui-theme-mode-provider";
import React from "react";
import { AppBarUserOptionsComponent } from "./appBarUserOptions";

export const appBarOptions = (): IAppBarOptions => {
  return {
    show: true,
    leftContentOptions: {
      show: true
    },
    mainContent: <div style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }}>
      <p>Bets Provider Tools</p>
      <span style={{ flex: 1 }}></span>
      <ThemeModeToggleComponent />
      <AppBarUserOptionsComponent />
    </div >,
    style: {
      background: '#5F6F94',
      minHeight: 55,
      padding: '5px 0px',
      boxSizing: 'border-box',
    },
  }
}